import { Button, FormField, Input, Link, Modal, SpaceBetween } from '@cloudscape-design/components';
import { mdiCheck, mdiClockStarFourPointsOutline, mdiClose, mdiDeleteOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect, useState } from 'react';
import { btnIcon } from '../resources/types';
import BadgeCustom from './extras/BadgeCustom';
interface TPModalProps {
  close?: boolean;
  clear?: boolean;
  now?: boolean;
  start?: number;
  end?: number;
  title?: string;
  subTitle?: string;
  time?: string;
  disabled?: boolean;
  readonly?: boolean;
  //onDismiss: () => void;
  onConfirm?: (time: string) => void;
}
const TPModal: React.FC<TPModalProps> = ({
  close = false,
  clear = true,
  now = true,
  start = undefined,
  end = undefined,
  title = 'Seleccione',
  subTitle = '',
  time = "",
  disabled = false,
  readonly = false,
  onConfirm,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [hour, setHour] = useState<number>();
  const [minute, setMinute] = useState<number>();
  const [minute10, setMinute10] = useState<number>();
  const [internalTime, setInternalTime] = useState<string>(time);

  const onDismiss = () => {
    setShowModal(false);
  }
  /*
  const timeClear = () => {
    setHour(undefined);
    setMinute(undefined);
    setMinute10(undefined);
    time = '';
    onConfirm?.('');
  }
    */

  const timeClear = () => {
    setHour(undefined);
    setMinute10(undefined);
    setMinute(undefined);
    onConfirm?.("");
    setShowModal(false);
  };

  useEffect(() => {
    setInternalTime(time);
    if (time.length === 5) {
      const parts = time.split(":");
      setHour(parseInt(parts[0]))
      setMinute10(parseInt(parts[1].split("")[0]));
      setMinute(parseInt(parts[1].split("")[1]));
    }

  }, [time]);

  useEffect(() => {
    if (hour !== undefined && minute10 !== undefined && minute !== undefined) {
      const formatted = `${hour.toString().padStart(2, '0')}:${minute10}${minute}`;
      setInternalTime(formatted);
      //onConfirm(formatted);
      //setShowModal(false)
    } else {
      setInternalTime("");
    }
  }, [hour, minute, minute10]);



  return (
    <>
      <div onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true)
      }} style={{ cursor: 'pointer', maxWidth: 200 }}>
        <Input value={internalTime} onChange={() => { }} placeholder='Seleccionar hora'
          inputMode="none"
          readOnly={readonly}
          disabled={disabled}
        />
      </div>
      <Modal
        visible={showModal}
        onDismiss={onDismiss}
        size="small"
        header={title}

        footer={
          <SpaceBetween direction='horizontal' size='xs'>
            {close && (
              <Button style={{ root: btnIcon }} onClick={onDismiss}><Icon path={mdiClose} size={1} /></Button>
            )}
            {clear && (
              <Button style={{ root: btnIcon }} onClick={timeClear}><Icon path={mdiDeleteOutline} size={1} /></Button>
            )}
            {now && (
              <Button style={{ root: btnIcon }}
                onClick={() => {
                  const nowData = new Date();
                  const h = nowData.getHours();
                  const m = nowData.getMinutes();

                  // 1. Still update internal state so the UI looks right if it stayed open
                  setHour(h);
                  setMinute10(Math.floor(m / 10));
                  setMinute(m % 10);

                  // 2. Format the string manually and send it NOW
                  const timeString = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
                  onConfirm?.(timeString);

                  // 3. Close the modal
                  setShowModal(false);
                }}
              ><Icon path={mdiClockStarFourPointsOutline} size={1} /></Button>
            )}
            <Button style={{ root: btnIcon }} onClick={() => {
              onConfirm?.(internalTime); // Pass the state value back to the parent
              setShowModal(false);
            }}><Icon path={mdiCheck} size={1} /></Button>
          </SpaceBetween>
        }
      >
        <FormField label={subTitle} stretch>
          <SpaceBetween direction='horizontal' size='xs'>
            <div style={{ display: "grid", gridTemplateColumns: "1fr" }}>
              {Array.from({ length: 12 }, (_, i) => (
                <BadgeCustom key={i} color={(hour && i === hour) ? 'blue' : 'lightgrey'}
                  onClick={() => {
                    setHour(i);
                  }}>
                  {(i + (0)).toString().padStart(2, '0')}
                </BadgeCustom>
              ))}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr" }}>
              {Array.from({ length: 12 }, (_, i) => (
                <BadgeCustom
                  onClick={() => {
                    setHour(i + 12);
                  }}
                  key={i + 12} color={(hour && i + 12 === hour) ? 'blue' : 'lightgrey'}>
                  {(i + (12)).toString().padStart(2, '0')}
                </BadgeCustom>
              ))}
            </div>
            <div style={{ width: 120, textAlign: "center" }}>
              <SpaceBetween direction='vertical' size='xs'>
                <Link variant="awsui-value-large">
                  {hour != undefined ? hour.toString().padStart(2, '0') : "--"}:{minute10 !== undefined && minute !== undefined ? `${minute10}${minute}` : "--"}
                </Link>
                <div style={{ textAlign: "center" }}>
                  <BadgeCustom size="large" color={hour === undefined ? "lightgrey" : hour < 12 ? "blue" : "lightgrey"}
                    onClick={() => {
                      if (hour !== undefined && hour >= 12) {
                        setHour(hour - 12);
                      }
                    }}
                  >AM</BadgeCustom>
                  <BadgeCustom size="large" color={hour === undefined ? "lightgrey" : hour >= 12 ? "blue" : "lightgrey"}
                    onClick={() => {
                      if (hour !== undefined && hour < 12) {
                        setHour(hour + 12);
                      }
                    }}>PM</BadgeCustom>
                </div>
              </SpaceBetween>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr" }}>
              {Array.from({ length: 6 }, (_, i) => (
                <BadgeCustom
                  onClick={() => {
                    setMinute10(i);
                  }}
                  key={`M${i}`} color={(minute10 !== undefined && i === minute10) ? 'blue' : 'lightgrey'}>
                  {(i).toString() + '_'}
                </BadgeCustom>
              ))}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr" }}>
              {Array.from({ length: 10 }, (_, i) => (
                <BadgeCustom
                  onClick={() => {
                    setMinute(i);
                  }}
                  key={`MM${i}`} color={(minute !== undefined && i === minute) ? 'blue' : 'lightgrey'}>
                  {(i).toString().padStart(2, '0')}
                </BadgeCustom>
              ))}
            </div>
          </SpaceBetween>
        </FormField>
      </Modal >
    </>
  );
};

export default TPModal;